import { FC } from 'react';
import { Skeleton, Stack } from '@mui/material';
import MainCard from 'components/MainCard';

// A single stat-card placeholder shaped like EcommerceDataCard
// (icon avatar + title/value lines + chart strip).
const StatCardSkeleton: FC = () => (
  <MainCard contentSX={{ p: 2.25 }}>
    <Stack spacing={1.5}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Skeleton variant="rounded" width={44} height={44} />
        <Skeleton variant="text" width={48} height={20} />
      </Stack>
      <Skeleton variant="text" width="60%" height={18} />
      <Skeleton variant="text" width="40%" height={30} />
      <Skeleton variant="rounded" width="100%" height={56} />
    </Stack>
  </MainCard>
);

export default StatCardSkeleton;
